import React, { useState, useEffect, useRef } from "react";
import axiosMain from "../http/axiosMain";
import "../Assets/css/Chatbot.css";
import { Paperclip } from 'lucide-react';


const Chatbot = () => {
  const [message, setMessage] = useState(""); // Input text
  const [chatHistory, setChatHistory] = useState([]); // Chat messages
  const [loading, setLoading] = useState(false);
  const [listening, setListening] = useState(false); // Mic state

  const chatContainerRef = useRef(null);

  let recognition = null;
  if ("webkitSpeechRecognition" in window || "SpeechRecognition" in window) {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
  }

  const startListening = () => {
    if (!recognition) {
      alert("Your browser does not support Speech Recognition.");
      return;
    }
    setListening(true);
    recognition.start();

    recognition.onresult = (event) => {
      const speechResult = event.results[0][0].transcript;
      console.log("Voice input:", speechResult);
      setMessage(speechResult); // 👈 Fill search box only
    };

    recognition.onend = () => {
      setListening(false);
    };

    recognition.onerror = (event) => {
      console.error("Speech Recognition Error:", event.error);
      setListening(false);
    };
  };

  const handleSendMessage = async () => {
    if (!message.trim()) return; // Skip empty input

    // Add user message to chat history
    const userMessage = { sender: "user", text: message };
    setChatHistory((prev) => [...prev, userMessage]);

    try {
      setLoading(true);

      // Send POST request to API
      const response = await axiosMain.post("/api/chatbot/", { message });

      // Add bot response to chat history
      const botMessage = {
        sender: "bot",
        text: response.data.data || "Sorry, I couldn't find an answer.",
      };
      setChatHistory((prev) => [...prev, botMessage]);

      setMessage(""); // Clear input
    } catch (error) {
      console.error("Error:", error);

      const errorMessage = {
        sender: "bot",
        text: "Error: Could not connect to the chatbot API.",
      };
      setChatHistory((prev) => [...prev, errorMessage]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  // Auto scroll to bottom when a new message arrives
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [chatHistory]);

  return (
    <div className="container-fluid chatbot-screen d-flex flex-column justify-content-between min-vh-100" style={{ padding: "none !iportant" }}>
      {/* Header */}
      <div className="row justify-content-center align-items-center text-center pt-5">
        <div className="col-12">
          <h2 className="fw-bold mb-4">How can we assist you today?</h2>
          <p className="lead">
            Get expert guidance powered by AI agents. Ask your Questions
            <br /> and start your conversation with ease.
          </p>
        </div>
      </div>

      {/* Chat History */}
      <div
        className="row flex-grow-1 overflow-auto px-3 mb-3 chat-history"
        ref={chatContainerRef}
      >
        <div className="col-12">
          {chatHistory.map((msg, idx) => (
            <div
              key={idx}
              className={`chat-message mb-2 d-flex ${msg.sender === "user"
                ? "justify-content-end"
                : "justify-content-start"
                }`}
            >
              <div
                className={`message-bubble px-3 py-2 rounded ${msg.sender === "user" ? "user-bubble" : "bot-bubble"
                  }`}
              >
                {msg.text}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer Input */}
      <div className="row mt-auto">
        <div className="col-12">
          <div className="chatbot-footer d-flex align-items-center py-2" style={{paddingLeft:"none",paddingRight:"8px"}}>
            {/* Send Button */}
            <button
              className="file-btn ms-2"
            // onClick={handleSendMessage}
            >
              {/* <i className="bi bi-arrow-right"></i> */}
              <Paperclip />
            </button>

            {/* Input Box */}
            <input
              type="text"
              className="form-control border-0 shadow-none"
              placeholder="Type or speak your question here"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={loading}
            />
            {/* Mic Icon */}
            <i
              className={`bi ${listening ? "bi-mic-fill text-danger" : "bi-mic"
                } fs-5 me-2 mic-icon`}
              onClick={startListening}
              title="Speak your question"
              style={{ cursor: "pointer" }}
            ></i>
            {/* Send Button */}
            <button
              className="send-btn ms-2"
              onClick={handleSendMessage}
              disabled={loading}
            >
              {loading ? (
                <span className="spinner-border spinner-border-sm"></span>
              ) : (
                <i className="bi bi-arrow-right"></i>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
